import { Injectable } from "@angular/core";

function _window(): Window {
    // return the global native browser window object
    return window;
}

@Injectable({
    providedIn: "root",
})
export default class WindowService {
    get nativeWindow(): Window {
        return _window();
    }
}
